import { useTranslation } from 'react-i18next'
import styled from 'styled-components'

import { Dialog } from '@root/shared/ui-kit'

import type { ChildrenProps, ClassNameProps } from '@root/shared/react'
import type { DialogControlProps } from '@root/shared/ui-kit'

type ReportDialogProps = {} & ClassNameProps &
  DialogControlProps &
  ChildrenProps

export const ReportDialog: React.FC<ReportDialogProps> = ({
  className,
  children,
  onOpenChange,
  open,
}) => {
  const { t } = useTranslation()

  return (
    <Dialog
      variant="bordered"
      open={open}
      onOpenChange={onOpenChange}
      describedBy={t('common.report')}
    >
      <Dialog.Header title={t('common.report')} />
      <Content className={className}>{children}</Content>
    </Dialog>
  )
}

const Content = styled.div`
  width: 360px;

  padding: 10px;
`
